import type { Profession } from 'app/services/oabEligibility/types';

export type OnboardingBranch = 'lawyer' | 'not_lawyer';

// No answer yields no branch: absence reads as "pre-gate cohort" in Metabase, a filler value would not.
export function professionToOnboardingBranch(
  profession?: Profession | null,
): OnboardingBranch | undefined {
  if (!profession) {
    return undefined;
  }

  return profession === 'OTHER' ? 'not_lawyer' : 'lawyer';
}
